/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
// biome-ignore lint/suspicious/noExplicitAny: setting custom property on window
(window as any).__Zone_disable_customElements = true;
